import UTCTooltip from '../../UTCTooltip/UTCTooltip';
import InvitationStepper from '../../InvitationStepper/InvitationStepper';
import React from 'react';
import styled from 'styled-components';
import { Dialog } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import emailSlice from '../../../store/email/slice';
import errorSlice from '../../../store/error/slice';
import { selectCurrentUser } from '../../../store/selectors';
import { getUserOffset } from '../../../helpers/timezone';
import { INVITATION_INPUT_TYPE } from '../../InvitationRecipientPicker/InvitationRecipientPicker';
import { BasicInvitationFormFields } from '../../../store/recruitment/types';
import { InfoGetDTO } from '../../../store/info/types';
import infoSlice from '../../../store/info/slice';

interface Props {
  removeEmailAction: () => void;
  removePreviewAction: () => void;
  clearValidationErrorsAction: () => void;
  handleClose: () => void;
  getInfoAction: (data: InfoGetDTO) => void;
  timezone: string | null;
  initType?: INVITATION_INPUT_TYPE;
  initInput?: BasicInvitationFormFields[] | number[];
  initStep?: number;
  title: string;
}

const InvitationDialog: React.FC<Props> = ({
  removeEmailAction,
  removePreviewAction,
  clearValidationErrorsAction,
  handleClose,
  getInfoAction,
  timezone,
  initType,
  initInput,
  initStep,
  title,
}) => {
  const minStep = initStep ?? 0;
  const [step, setStep] = React.useState<number>(minStep);

  return (
    // TODO: use SimpleDialog instead of Dialog?
    <StyledDialog className="custom-dialog">
      <StyledInvitationTitle>
        <div className="flex justify-between items-center">
          <span>{title}</span>
          {step == 1 && <UTCTooltip utcOffset={getUserOffset(timezone)} />}
        </div>
      </StyledInvitationTitle>
      <InvitationStepper
        initType={initType}
        initInput={initInput}
        minStep={minStep}
        step={step}
        onStepChange={setStep}
        onClose={(formState) => {
          removeEmailAction();
          removePreviewAction();
          clearValidationErrorsAction();
          if (formState == 'SENDING') {
            getInfoAction({ friendlyName: 'invitations' }); // Refresh data
          }
          handleClose();
        }}
      />
    </StyledDialog>
  );
};

const StyledDialog = styled(Dialog)`
  .k-grid {
    min-height: 22rem;
  }
`;

const StyledInvitationTitle = styled.h2`
  border-bottom: 2px dotted #e3e5e6;
  padding: 0;
  margin-bottom: 2rem;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0075em;
`;

const mapStateToProps = (state: AppState) => ({
  timezone: selectCurrentUser(state).person.timezone,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  removeEmailAction: () => dispatch(emailSlice.actions['REMOVE:EMAIL']()),
  removePreviewAction: () => dispatch(emailSlice.actions['REMOVE:PREVIEW']()),
  clearValidationErrorsAction: () => dispatch(errorSlice.actions['CLEAR:VALIDATION_ERRORS']()),
  getInfoAction: (data: InfoGetDTO) => dispatch(infoSlice.actions.GET(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvitationDialog);
